// src/services/supporters.js — who wears the Supporter badge (web). The app's stores/supporters.ts, the same rules.
//
// 🟢 ONE CACHED DIRECTORY, NOT A READ PER NAME. A name drawn anywhere asks `supporterOf(uid)` (synchronous). An
//    unknown uid is queued; queued uids are read together, up to 30 per query, a beat later; every answer — a badge
//    or "none" — is kept for six hours (in memory and in localStorage), so a chat list of 300 names costs ten
//    reads once, and nothing after. Only the server writes supporters/{uid}, and only while the badge is shown.
import { collection, documentId, getDocs, getFirestore, query, where } from 'firebase/firestore';
import app from '../config/firebase';

const TTL_MS = 6 * 60 * 60 * 1000;
const KEY = 'alloapp_supporters_v1';
const mem = new Map();   // uid → { tier, expiresAtMs, at } | { none: true, at }
const subs = new Set();
const queued = new Set();
let timer = null;
try { const raw = JSON.parse(localStorage.getItem(KEY) || '{}'); for (const [k, v] of Object.entries(raw)) if (v && Date.now() - v.at < TTL_MS) mem.set(k, v); } catch { /* none */ }
const persist = () => { try { const o = {}; for (const [k, v] of mem) o[k] = v; localStorage.setItem(KEY, JSON.stringify(o)); } catch { /* none */ } };
const notify = () => subs.forEach((f) => { try { f(); } catch { /* none */ } });

export function subscribeSupporters(f) { subs.add(f); return () => subs.delete(f); }

async function flush() {
  timer = null;
  const ids = Array.from(queued); queued.clear();
  for (let i = 0; i < ids.length; i += 30) {
    const part = ids.slice(i, i + 30);
    try {
      const snap = await getDocs(query(collection(getFirestore(app), 'supporters'), where(documentId(), 'in', part)));
      const found = new Set();
      snap.forEach((d) => { found.add(d.id); const x = d.data(); mem.set(d.id, { tier: x.tier, expiresAtMs: Number(x.expiresAtMs) || 0, at: Date.now() }); });
      for (const id of part) if (!found.has(id)) mem.set(id, { none: true, at: Date.now() });
    } catch { for (const id of part) mem.set(id, { none: true, at: Date.now() - TTL_MS + 5 * 60 * 1000 }); }   // try again in 5 minutes
  }
  persist(); notify();
}

/** { tier } while the badge is running, else null (synchronous; asks in the background when unknown) */
export function supporterOf(uid) {
  if (!uid) return null;
  const v = mem.get(uid);
  if (!v || Date.now() - v.at > TTL_MS) {
    queued.add(uid);
    if (!timer) timer = setTimeout(flush, 120);
  }
  if (!v || v.none) return null;
  if (v.expiresAtMs && v.expiresAtMs < Date.now()) return null;
  return { tier: v.tier };
}
/** my own badge changed (paid, hidden): ask again */
export function forgetSupporter(uid) { mem.delete(uid); persist(); notify(); }
